import { useEffect, useState } from 'react';
import { AxiosHelper } from '../helpers/axiosHelper';

const useSettings = () => {
  const [yellowTime, setYellowTime] = useState<string | undefined>();
  const [redTime, setRedTime] = useState<string | undefined>();
  const [barcodeRescanTime, setBarcodeRescanTime] = useState<string | undefined>();

  useEffect(() => {
    AxiosHelper.getWithAxios('/settings').then((res) => {
      const settings = res.data;
      setYellowTime(settings.yellow_time);
      setRedTime(settings.red_time);
      setBarcodeRescanTime(settings.barcode_rescan_time);
    });
  }, []);

  const saveSettings = async (yellow_time: string, red_time: string, barcode_rescan_time: string) => {
    const res = await AxiosHelper.postWithAxios('/settings', { yellow_time, red_time, barcode_rescan_time });
    if (res.status === 200) {
      setYellowTime(yellow_time);
      setRedTime(red_time);
      setBarcodeRescanTime(barcode_rescan_time);
    }
  };
  return { yellowTime, redTime, barcodeRescanTime, saveSettings };
};

export default useSettings;
